var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collectives-infos"},[_c('v-chip',{staticClass:"collectives-content mx-auto ma-md-2 ml-md-8",attrs:{"close":""},on:{"click":function($event){return _vm.$router.push(_vm.cb)},"click:close":function($event){return _vm.close()}}},[_vm._v(" "+_vm._s(_vm.content.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }